import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get, post } from '../../services/apiServices'
import { token } from '../../services/authServices'
import {
    accountsAction,
    usersAction
} from '../../actions/contentActions'
import ClassRoomsContainer from './ClassRoomsContainer'
import TeachersContainer from './TeachersContainer'
import ReportContainer from './ReportContainer'
import Users from '../content/Users'
import Import from '../content/Import'
import Tabs from 'material-ui/Tabs';
import { Tab } from 'material-ui/Tabs';

const mapStateToProps = state => {
    return {
        account: state.account,
        users: state.users
    }
}

const mapDispatchToProps = dispatch => {
    return {
        initUsers: (id) => {
            dispatch(usersAction(id))
        },
        usersPageChange: (id, page) => {
            dispatch(usersAction(id, page))
        },
    }
}

class AccountContainer extends Component {
    state = {
        selectedAccount: {},
        activeTab: 0
    }
    componentWillMount() {
        let accountId = this.props.accountId
        get(`/admin/accounts/${accountId}`, token).then(res => {
            let selectedAccount = res.data.data
            this.setState({ selectedAccount })
        })
    }
    handleTabChange = (event, activeTab) => {
        this.setState({ activeTab });
    }
    render() {
        const { account } = this.props
        const isAdmin = account && account.user.type === 'superadmin'
        const selectedAccount = this.state.selectedAccount
        const isSchool = selectedAccount.type === 'school'
        const activeTab = this.state.activeTab
        return (
            <div>
                {isAdmin ? <React.Fragment>
                    <div className="top-panel">
                        <Tabs
                            indicatorColor="primary"
                            textColor="primary"
                            value={activeTab}
                            onChange={this.handleTabChange}>
                            <Tab label="Users" />
                            {isSchool && <Tab label="Class Rooms" />}
                            {isSchool && <Tab label="Teachers" />}
                            {isSchool && <Tab label="Import" />}
                            <Tab label="Reports" />
                            
                        </Tabs>
                    </div>
                    {activeTab === 0 && selectedAccount.id && <Users
                        accountId={selectedAccount.id}
                        initUsers={this.props.initUsers}
                        pageChange={this.props.usersPageChange}
                        users={this.props.users}
                    />}
                    {activeTab === 1 && isSchool && selectedAccount.id && <ClassRoomsContainer
                        accountId={selectedAccount.id}
                    />}
                    {activeTab === 2 && isSchool && selectedAccount.id && <TeachersContainer
                        accountId={selectedAccount.id}
                    />}
                    {isSchool && activeTab === 3 && selectedAccount.id && <Import
                        accountId={selectedAccount.id}
                    />}
                    {((activeTab === 4 && isSchool) || (!isSchool && activeTab === 1)) && selectedAccount.id && <ReportContainer
                        isSchool={isSchool}
                        accountId={selectedAccount.id}
                    />}
                </React.Fragment>
                    :
                    selectedAccount.id && <ReportContainer
                        isSchool={isSchool}
                        accountId={selectedAccount.id}
                    />
                }
            </div>
        )
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AccountContainer);



// WEBPACK FOOTER //
// ./src/components/containers/AccountContainer.js